__turbopack_context__.v({
  "clearButton": "KT_MTq_clearButton",
  "input": "KT_MTq_input",
  "mantineRoot": "KT_MTq_mantineRoot",
  "root": "KT_MTq_root",
  "section": "KT_MTq_section",
  "wrapper": "KT_MTq_wrapper",
});
